module.exports = __webpack_public_path__ + "assets/img/bohai_logo@2x.453a8f78.png";